var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMapPin = function SvgMapPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#map-pin_svg__a)",
    fillRule: "evenodd",
    d: "M67 34.947c0 17.273-19.722 32.086-25.455 36.027a2.697 2.697 0 0 1-3.09 0C32.722 67.033 13 52.22 13 34.947 13 20.066 25.09 8 40 8s27 12.066 27 26.947Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M51.813 34.947c0 6.511-5.29 11.79-11.813 11.79-6.524 0-11.813-5.279-11.813-11.79 0-6.51 5.29-11.79 11.813-11.79 6.524 0 11.813 5.28 11.813 11.79Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "map-pin_svg__a",
    x1: 67.659,
    x2: 12.972,
    y1: 39.011,
    y2: 39.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CA72",
    stopOpacity: 0.2
  })))));
};
export default SvgMapPin;